import React, { useEffect, Fragment } from 'react';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs';
import BranchContain from '../../../Component/DashboardQeza/Branch';

const Branch = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    return (
        <Fragment>
            <Breadcrumbs parent="Cabang Klinik" title="Daftar Cabang Klinik" />
            <BranchContain />
        </Fragment>
    );
};
export default Branch;